import AOS from 'aos'

document.addEventListener('DOMContentLoaded', () => {
  AOS.init({
    duration: 1000
  })
});
